import LandingHero from "../components/LandingHero";
import RotatingGallery from "../components/RotatingGallery";
import DynamicProductsSection from "../components/DynamicProductsSection";
import FeatureSection from "../components/FeatureSection";
import ProductShowcase from "../components/ProductShowcase";
import BrandVideo from "../components/BrandVideo";
import MakeupSpotlight from "../components/MakeupSpotlight";
import NewsletterSection from "../components/NewsletterSection";
import InstagramGallery from "../components/InstagramGallery";
import BlogSection from "../components/BlogSection";
import TestimonialSection from "../components/TestimonialSection";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <main className="bg-white">
      {/* Hero Section - "Look & Feel Modern" */}
      <LandingHero />

      {/* Rotating Gallery with 4 images */}
      <RotatingGallery />

      {/* Feature Section - "Making Every Face Perfect" */}
      <FeatureSection />

      {/* Dynamic Products Section - Auto-scrolling Carousel */}
      <DynamicProductsSection />

      {/* Product Showcase - V-Beauty Pack */}
      <ProductShowcase />

      {/* Brand Video Section */}
      <BrandVideo />

      {/* Makeup Spotlight Section */}
      <MakeupSpotlight />

      {/* Newsletter Section */}
      <NewsletterSection />

      {/* Instagram Gallery */}
      <InstagramGallery />

      {/* Blog Section - Latest Posts */}
      <BlogSection />

      {/* Testimonials */}
      <TestimonialSection />

      {/* Footer */}
      <Footer />
    </main>
  );
};

export default Home;
